"use client"

import { useEffect, useRef } from "react";

const KONAMI_SEQUENCE: string[] = [
    "ArrowUp", "ArrowUp",
    "ArrowDown", "ArrowDown",
    "ArrowLeft", "ArrowRight",
    "ArrowLeft", "ArrowRight",
    "b", "a",
];

/**
 * Listens for the Konami Code key sequence and invokes the callback when completed.
 * Resets progress on any incorrect key press.
 */
export function useKonamiCode(callback: () => void): void {
    const indexRef = useRef<number>(0);
    const callbackRef = useRef(callback);

    // Keep callback ref fresh without re-attaching the listener
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            const expectedKey = KONAMI_SEQUENCE[indexRef.current];

            if (e.key === expectedKey) {
                indexRef.current += 1;

                if (indexRef.current === KONAMI_SEQUENCE.length) {
                    indexRef.current = 0;
                    callbackRef.current();
                }
            } else {
                indexRef.current = 0;
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
}
